var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColumnNegative = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 16L0 16",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 7,
  width: 4,
  height: 7,
  className: "chart-qualitative-01"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 25,
  width: 4,
  height: 7,
  transform: "rotate(180 16 25)",
  className: "chart-qualitative-02"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 3,
  width: 4,
  height: 11,
  className: "chart-qualitative-01"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 29,
  width: 4,
  height: 11,
  transform: "rotate(180 10 29)",
  className: "chart-qualitative-02"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  width: 4,
  height: 14,
  className: "chart-qualitative-01"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 32,
  width: 4,
  height: 14,
  transform: "rotate(180 4 32)",
  className: "chart-qualitative-02"
})));
export { SvgColumnNegative as ReactComponent };
export default __webpack_public_path__ + "column_negative.abc3f7ff73b87c67bed05c0ec03b3271.svg";